import { post } from '@/utils/request'

export function getList(data) {
    return post('admin/desk/list', data)
}
export function getAdd(data) {
    return post('admin/desk/add', data)
}
export function getDel(data) {
    return post('admin/desk/del', data)
}
export function getEdit(data) {
    return post('admin/desk/edit', data)
}
export function getChange(data) {
    return post('admin/desk/editState', data)
}

